import { composeWrappers } from "@redotech/react-util/component";
import { memo } from "react";
import { Outlet } from "react-router-dom";
import { ModalProvider } from "./contexts/modal-context";
import { PickSessionProvider } from "./contexts/pick-session-context";

export const ScanRoot = memo(function ScanRoot() {
  return composeWrappers(
    (inner) => <PickSessionProvider>{inner}</PickSessionProvider>,
    (inner) => <ModalProvider>{inner}</ModalProvider>,
  )(<Outlet />);
});
